import React from 'react';
import { positions } from '../../CustomerListConstants';
import { PositionDropdown, SalutationDropdown } from './Dropdown/Dropdown';
import useContactEntry from './useContactEntry';
import LinkToSalesforce from '../../../LinkToSalesforce';
const swap = (obj) =>
  Object.fromEntries(Object.entries(obj).map((a) => a.reverse()));

const positions_opp = swap(positions);
const fields = [
  'Salutation',
  'FirstName',
  'LastName',
  'Email',
  'Phone',
  'Position__c',
];

const ContactEntry = (props) => {
  const { contact, onCancel, onEdit, onSave, mode, onChange } =
    useContactEntry(props.props);

  if (mode === 'read') {
    return (
      <ReadModeContactEntry
        onEdit={onEdit}
        contact={contact}
        isNew={props.isNew}
      />
    );
  }

  return (
    <EditModeContactEntry
      contact={contact}
      onCancel={onCancel}
      onSave={onSave}
      onChange={onChange}
      isNew={props.isNew}
    />
  );
};

const BrandCenterActive = (props) => {
  const contact= props.contact;
  const active = contact.Brandcenter_Active__c === true;

  if (active) {
    return <span role="img" aria-label="enabled" title="Brandcenter Enabled" style={{height: '16px'}}>✅</span>
  }

  return <span role="img" aria-label="disabled" title="Brandcenter Disabled" style={{height: '16px'}}>✖️</span>
}

const ReadModeContactEntry = (props) => {
  const { contact, onEdit, isNew } = props;
  let classList = 'read-mode';
  if (isNew) {
    classList = `${classList} table-success`;
  }
  return (
    <tr className={classList}>
      <td>
        <div style={{display: 'flex', alignItems: 'center', width: '100px'}}>
        <LinkToSalesforce obj={contact}/>
        <BrandCenterActive contact={contact}/>
        </div>
      </td>
      {fields.map((field) => (
        <td key={field}>
          {field !== 'Position__c' && field !== 'Salutation' && (
            <span>{contact[field]}</span>
          )}
          {field === 'Salutation' && <span>{contact[field]}</span>}
          {field === 'Position__c' && (
            <>
              {contact[field].map((position) => (
                <span key={position}>{positions_opp[position]} &nbsp;</span>
              ))}
            </>
          )}
        </td>
      ))}
      <td className='text-right'>
        <div className='btn-group' role='group' aria-label='Basic example'>
          <button
            type='button'
            className='btn btn-sm btn-primary'
            onClick={onEdit}
          >
            Edit
          </button>
        </div>
      </td>
    </tr>
  );
};

const EditModeContactEntry = (props) => {
  const { contact, onCancel, onSave, onChange, isNew } = props;

  const validateField = (field) => {
    if (!field) {
      return true;
    }
    return false;
  };
  const isButtonDisabled =
    validateField(contact.Email) ||
    validateField(contact.FirstName) ||
    validateField(contact.LastName);
  let classList = 'edit-mode';
  if (isNew) {
    classList = `${classList} table-success`;
  }
  return (
    <tr className={classList}>
      <td></td>
      {fields.map((field) => (
        <td key={field}>
          {field !== 'Position__c' && field !== 'Salutation' && (
            <input
              name={field}
              className='form-control'
              type='text'
              value={contact[field] || ''}
              onChange={onChange}
            />
          )}
          {field === 'Salutation' && (
            <SalutationDropdown
              name={field}
              value={contact[field]}
              className='custom-select'
              onChange={onChange}
            />
          )}
          {field === 'Position__c' && (
            <PositionDropdown
              name={field}
              value={contact[field]}
              className='custom-select'
              onChange={onChange}
              multiple={true}
            />
          )}
        </td>
      ))}
      <td className='text-right'>
        <div className='btn-group' role='group' aria-label='Basic example'>
          <button
            type='button'
            className='btn btn-sm btn-primary'
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type='button'
            className='btn btn-sm btn-primary'
            onClick={onSave}
            disabled={isButtonDisabled}
          >
            Save
          </button>
        </div>
      </td>
    </tr>
  );
};
export default ContactEntry;
